import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import MatchingConfig from './matchingConfig';

import {
  saveNSMatchingConfigToStore,
  getNSMatchingConfigListData
} from '../../../redux/actions/ns/matchingConfig';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    matchingConfigListData: state.nsMatchingConfig.matchingConfigList,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        saveNSMatchingConfigToStore,
        getNSGlobalSettingsPageInfo,
        getNSMatchingConfigListData
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MatchingConfig);
